import registerAdviceCommunication from "./adviceCommunication/AdviceCommunication";
import MultiFiltering from "./dynamicPageReload/init";
import { registerAppTracking } from "./appsTracking/AppsTracking";
import { eventLoader } from "@otto-ec/global-resources/event-loader";

eventLoader.onReady(3, () => MultiFiltering.init());
registerAppTracking();
registerAdviceCommunication();
